import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../API/EndPoints";
import AxiosInstance from "../../API/AxiosInstance";

export const fetchTodayAppointments = createAsyncThunk(
  "report/fetchTodayAppointments",
  async (doctorId, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        `${API_ENDPOINTS.GET_TODAY_APPOINTMENTS}?doctorId=${doctorId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const updateAppointmentStatus = createAsyncThunk(
  "report/updateAppointmentStatus",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.put(
        API_ENDPOINTS.UPDATE_APPOINTMENT_STATUS,

        credentials
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const rescheduleAppointment = createAsyncThunk(
  "report/rescheduleAppointment",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.put(
        API_ENDPOINTS.RESCHEDULE_APPOINTMENT,
        credentials
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const cancelAppointment = createAsyncThunk(
  "report/cancelAppointment",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        API_ENDPOINTS.CANCEL_APPOINTMENT,
        credentials
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

// ------------------ INITIAL STATE ------------------
const initialState = {
  todayAppointments: {
    loading: false,
    error: null,
    data: null,
  },
  updateStatus: {
    loading: false,
    error: null,
    data: null,
  },
  reschedule: {
    loading: false,
    error: null,
    data: null,
  },
  cancel: {
    loading: false,
    error: null,
    data: null,
  },
};

// ------------------ SLICE ------------------
const AppointmentSlice = createSlice({
  name: "Appointment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTodayAppointments.pending, (state) => {
        state.todayAppointments.loading = true;
        state.todayAppointments.error = null;
      })
      .addCase(fetchTodayAppointments.fulfilled, (state, action) => {
        state.todayAppointments.loading = false;
        state.todayAppointments.data = action.payload;
      })
      .addCase(fetchTodayAppointments.rejected, (state, action) => {
        state.todayAppointments.loading = false;
        state.todayAppointments.error = action.payload;
      });
    builder
      .addCase(updateAppointmentStatus.pending, (state) => {
        state.updateStatus.loading = true;
        state.updateStatus.error = null;
      })
      .addCase(updateAppointmentStatus.fulfilled, (state, action) => {
        state.updateStatus.loading = false;
        state.updateStatus.data = action.payload;
      })
      .addCase(updateAppointmentStatus.rejected, (state, action) => {
        state.updateStatus.loading = false;
        state.updateStatus.error = action.payload;
      });
    builder
      .addCase(rescheduleAppointment.pending, (state) => {
        state.reschedule.loading = true;
        state.reschedule.error = null;
      })
      .addCase(rescheduleAppointment.fulfilled, (state, action) => {
        state.reschedule.loading = false;
        state.reschedule.data = action.payload;
      })
      .addCase(rescheduleAppointment.rejected, (state, action) => {
        state.reschedule.loading = false;
        state.reschedule.error = action.payload;
      });
    builder
      .addCase(cancelAppointment.pending, (state) => {
        state.cancel.loading = true;
        state.cancel.error = null;
      })
      .addCase(cancelAppointment.fulfilled, (state, action) => {
        state.cancel.loading = false;
        state.cancel.data = action.payload;
      })
      .addCase(cancelAppointment.rejected, (state, action) => {
        state.cancel.loading = false;
        state.cancel.error = action.payload;
      });
  },
});

export default AppointmentSlice.reducer;
